import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-263fb89d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-widgets" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "social-dock__nav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-users-gear" }, null, -1))
const _hoisted_5 = ["href", "title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-phone-volume" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-address-card" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-house" }, null, -1))

import { ref, onMounted, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import store from "@/store/index";
import commons from "@/utils/Common";
import { COMPANY_DETAIL_COOKIE } from "@/const/ConstCookies";
import chatBg from "@/assets/images/social/chat_bg.png";
import { CONTACT, DASHBOARD, FAVOURITE, HOME } from '@/const/path'


export default /*#__PURE__*/_defineComponent({
  __name: 'Social',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const show = ref(false);
const chatBgUrl = chatBg;

const company = computed(() => {
  try {
    const fromStore = commons.getCokiesCompany?.()
    if (fromStore && Object.keys(fromStore).length) return fromStore
    const cookie = commons.getTenantCookie?.(COMPANY_DETAIL_COOKIE)
    if (cookie) {
      return typeof cookie === 'string' ? JSON.parse(cookie) : cookie
    }
    const legacy = JSON.parse(commons.getTenantLocalStorage?.(COMPANY_DETAIL_COOKIE) || 'null')
    return legacy || {}
  } catch {
    return {};
  }
});

const phoneRaw = computed(() => {
  const p = company.value?.phone || company.value?.hotline || "1900989829";
  return String(p).replace(/\s+/g, "");
});

const phoneHref = computed(() => `tel:${phoneRaw.value}`);
const phoneTitle = computed(
  () =>
    `${t("text.contactHotline")}: ${company.value?.phone || phoneRaw.value}`
);

const managePage = () => {
  router.push({ path: DASHBOARD });
};

const goFavorites = () => {
  router.push({ path: FAVOURITE });
};

const loadData = () => {
  show.value = commons.getToken() != null;
};

onMounted(async () => {
  await loadData();
});

const isLoadLogin = computed(() => store.getters.isLoadLogin);
watch(isLoadLogin, async () => {
  await loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_back_top = _resolveComponent("a-back-top")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", {
      class: "social-dock",
      "aria-label": _ctx.$t('text.quickContact')
    }, [
      _createElementVNode("div", {
        class: "social-dock__bg",
        style: _normalizeStyle({
          WebkitMaskImage: `url(${_unref(chatBgUrl)})`,
          maskImage: `url(${_unref(chatBgUrl)})`,
        }),
        "aria-hidden": "true"
      }, null, 4),
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_a_tooltip, {
          placement: "left",
          title: _ctx.$t('text.manageWebsite'),
          color: "#102542"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_router_link, {
              class: "social-dock__item",
              to: _unref(DASHBOARD),
              title: _ctx.$t('text.manageWebsite')
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["to", "title"]), [
              [_vShow, show.value]
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_a_tooltip, {
          placement: "left",
          title: _ctx.$t('text.contactPhone'),
          color: "#102542"
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "social-dock__item",
              href: phoneHref.value,
              title: phoneTitle.value
            }, _hoisted_7, 8, _hoisted_5)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_a_tooltip, {
          placement: "left",
          title: _ctx.$t('text.favoriteProducts'),
          color: "#102542"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "social-dock__item",
              to: _unref(FAVOURITE),
              title: _ctx.$t('text.favoriteProducts')
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["to", "title"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_a_tooltip, {
          placement: "left",
          title: _ctx.$t('text.contact'),
          color: "#102542"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "social-dock__item",
              to: _unref(CONTACT),
              title: _ctx.$t('text.contact')
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to", "title"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_a_tooltip, {
          placement: "left",
          title: _ctx.$t('text.home'),
          color: "#102542"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "social-dock__item",
              to: _unref(HOME),
              title: _ctx.$t('text.home')
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["to", "title"])
          ]),
          _: 1
        }, 8, ["title"])
      ])
    ], 8, _hoisted_2),
    _createVNode(_component_a_back_top, {
      "visibility-height": 400,
      class: "social-back-top"
    })
  ]))
}
}

})